<template>
  <page-listado>
    <page-header title="Repositorio Comercial" />
    <tabla :repositorios-comerciales="repositoriosComerciales" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import * as repositoriosComercialesApi from "@/services/repositoriosComerciales.js";
import Tabla from "./TablaRepositoriosComerciales.vue";

export default {
  components: { Tabla },
  data() {
    return {
      repositoriosComerciales: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        // this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.listar();
  },
  methods: {
    async listar() {
      this.repositoriosComerciales = await repositoriosComercialesApi.listar();
    },
    async eliminar(id) {
      await repositoriosComercialesApi.eliminar(id);
      this.listar();
    },
  },
};
</script>
